import React from 'react';
import { useTranslation } from 'react-i18next';

export default function CashoutRedemptionBanner() {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <div className="alert alert-info cashout-banner cashout-redemption-banner" role="alert">
      <p>{t('cashout-redemption-banner')}</p>
    </div>
  );
}
